<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-on:click="changeScale()">
            <SVGRuler class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Изменить масштаб</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="changePerspective()" v-show="activeStep === 'planeCategoriesForPerspectiveActivePlane'">
            <SVGStepsPerspective class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Настроить перспективу</span>
        </div>
    </div>
</template>

<script>
    import SVGScale from "../../SVG/SVGScale";
    import SVGStepsPerspective from "../../SVG/SVGStepsPerspective";
    import SVGRuler from "../../SVG/SVGRuler";
    export default {
        name: "LeftLowerBarChangeScale",
        components: {SVGRuler, SVGStepsPerspective, SVGScale},
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
        },
        methods: {
            changeScale() {
                this.$router.push({name: 'SetScale'}).catch(() => {});
            },
            changePerspective() {
                this.$router.push({
                    name: "SetPerspective",
                    params: {planeID: this.$route.params.planeID},
                    query: this.$route.query
                }).catch(() => {
                });
            }
        }
    }
</script>

<style scoped>
    /*.btn-perspective-icon {*/
    /*    width: 24px;*/
    /*    height: 24px;*/
    /*}*/
    /*.btn-scale-icon {*/
    /*    width: 26px;*/
    /*    height: 26px;*/
    /*}*/
</style>
